import angular from 'angular';

import emojiJson from './emoji.json';
import emojiUrl from './emoji.html';

export default function emoji($compile, $timeout, $document, $templateRequest) {
  'ngInject';

  return {
    restrict: 'A',
    require: 'ngModel',
    controller($localStorage, $element) {
      'ngInject';

      const controller = this;
      const element = $element[0];

      controller.categories = ['recent', 'people', 'places', 'nature', 'objects', 'symbols'];

      controller.emojis = emojiJson;
      controller.popupOpened = false;

      controller.activeCategory = controller.categories[1];

      controller.getRecentEmojis = function getRecentEmojis() {
        return $localStorage.recentEmojis || [];
      };

      controller.getEmojis = function getEmojis(category) {
        return category === 'recent'
          ? controller.getRecentEmojis()
          : controller.emojis[category].split(',');
      };

      controller.togglePopup = function togglePopup() {
        controller.popupOpened = !controller.popupOpened;
      };

      controller.emojiClicked = function emojiClicked(character) {
        const recent = $localStorage.recentEmojis || [];
        const index = recent.indexOf(character);

        // was already there
        if (index >= 0) {
          recent.splice(index, 1);
        }

        recent.unshift(character);
        $localStorage.recentEmojis = recent;

        const currentValue = controller.$model.$viewValue || '';
        let newValue;

        // if we support selectionStart we want to put the emoji where the cursor is
        if ('selectionStart' in element) {
          const currentSelection = element.selectionStart;
          newValue =
            currentValue.substring(0, currentSelection) +
            character +
            currentValue.substring(currentSelection);
          $timeout(() => {
            const newSelection = currentSelection + 2; // apparently emoji characters are 24 bit
            element.setSelectionRange(newSelection, newSelection);
            element.focus();
          });
        } else {
          newValue = currentValue + character;
          $timeout(() => {
            element.focus();
          });
        }

        controller.$model.$setViewValue(newValue);
        controller.$model.$render();

        controller.popupOpened = false;
      };
    },
    controllerAs: 'emojiCtrl',
    link($scope, $element, $attrs, $ngModel) {
      const controller = $scope.emojiCtrl;
      controller.$model = $ngModel;

      if (__TEST__) {
        // None of the stuff below here is unit tested because of jqLite problems
        return;
      }

      init();

      async function init() {
        const emojiSelector = angular.element(await $templateRequest(emojiUrl));
        emojiSelector
          .on('click', () => {
            $element[0].focus();
          })
          .on('mousedown', () => {
            $timeout(() => {
              $element[0].focus();
            });
          });

        const options = $scope.$eval($attrs.emoji) || {};
        if ('placement' in options) {
          emojiSelector.addClass(options.placement);
        }

        if (options.hidden) {
          return;
        }

        $element.after(emojiSelector);
        $compile(emojiSelector)($scope);

        $scope.$on('emoji:close-popup', () => {
          controller.popupOpened = false;
        });

        $element.on('keyup', (e) => {
          if (e.keyCode === 27) {
            // esc
            $scope.$apply(() => {
              controller.popupOpened = false;
            });
          }
        });

        function documentClickHandler(e) {
          const target = angular.element(e.target);

          if (!target.closest($element).length && !target.closest(emojiSelector).length) {
            $scope.$apply(() => {
              controller.popupOpened = false;
            });
          }
        }

        $document.on('click', documentClickHandler);
        $scope.$on('$destroy', () => {
          $document.off('click', documentClickHandler);
        });
      }
    },
  };
}
